import Image from "next/image";
import Link from "next/link";
import {urlForImage} from "../../sanity/lib/image";

// Componenti RichText ottimizzati per i banner
export const BannerRichTextComponents = {
    types: {
        image: ({ value }: any) => {
            return (
                <div className="relative w-full h-32 my-2 mx-auto">
                    <Image
                        className="object-contain"
                        src={urlForImage(value).url()}
                        alt="Banner Image"
                        fill
                        sizes="100vw"
                    />
                </div>
            );
        },
    },
    list: {
        bullet: ({ children }: any) => (
            <ul className="ml-4 list-disc space-y-1">{children}</ul>
        ),
        number: ({ children }: any) => (
            <ol className="ml-4 list-decimal space-y-1">{children}</ol>
        ),
    },
    block: {
        h1: ({ children }: any) => (
            <h1 className="font-bold leading-tight">{children}</h1>
        ),
        h2: ({ children }: any) => (
            <h2 className="font-bold leading-tight">{children}</h2>
        ),
        h3: ({ children }: any) => (
            <h3 className="font-bold leading-tight">{children}</h3>
        ),
        h4: ({ children }: any) => (
            <h4 className="font-bold leading-tight">{children}</h4>
        ),
        normal: ({ children }: any) => (
            <span className="leading-tight">{children}</span>
        ),
        blockquote: ({ children }: any) => (
            <blockquote className="border-l-white border-l-2 pl-3 my-2 italic">
                {children}
            </blockquote>
        ),
    },
    marks: {
        link: ({ children, value }: any) => {
            if (!value?.href) {
                console.warn('Link href is undefined or null:', value);
                return <span className="text-red-300">Invalid link</span>;
            }

            const rel = !value.href.startsWith("/")
                ? "noreferrer noopener"
                : undefined;

            return (
                <Link hrefLang="it"
                      href={value.href}
                      rel={rel}
                      className="underline decoration-white hover:decoration-blue-300 transition-colors"
                >
                    {children}
                </Link>
            );
        },
        strong: ({ children }: any) => (
            <strong className="font-bold">{children}</strong>
        ),
        em: ({ children }: any) => (
            <em className="italic">{children}</em>
        ),
    },
};
